import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function CardSaved() {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sid = new URLSearchParams(location.search).get("session_id");
    if (!sid) return setStatus("error");
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/advertiser/setup-status/${sid}`);
        if (data.card_saved) return setStatus("saved");
      } catch (e) {}
      if (tries++ < 8) setTimeout(poll, 2000);
      else setStatus("error");
    };
    poll();
  }, [location.search]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-10 text-center" data-testid="card-saved-result">
        {status === "checking" && <><Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold">Saving your card…</h1></>}
        {status === "saved" && <><CheckCircle2 className="w-14 h-14 text-primary mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold mb-2">Welcome, Founding Advertiser!</h1><p className="text-muted-foreground text-sm mb-4">Your location has been successfully enrolled in Velopaths as a Founding Advertiser. Your participation includes one advertiser location, visibility in the Velopaths Rider App, placement on the Velopaths map within an eligible zone, and one year of participation.</p><div className="text-left rounded-xl border border-primary/20 bg-primary/10 p-4 mb-4"><div className="text-sm font-heading font-bold mb-1">Participation Fee: $99 per year per location</div><p className="text-xs text-muted-foreground">You won't be charged until your bike rental shop approves your listing. Submit your listing for approval when ready. Renewal pricing may differ in future years as the platform expands.</p></div></>}
        {status === "error" && <><XCircle className="w-14 h-14 text-destructive mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold mb-2">Couldn't confirm your card</h1><p className="text-muted-foreground text-sm mb-6">You can add a payment method again from the Subscription tab.</p></>}
        {status !== "checking" && <Button onClick={() => navigate("/advertiser")} data-testid="card-saved-back" className="w-full">Go to dashboard</Button>}
      </div>
    </div>
  );
}
